import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';

import { analyticsTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const formatDateForServer = (date: Date) => {
  return dayjs(date).format('D/M/YYYY');
};

export const getReport: analyticsTypes.GetProphetReport = (params) => {
  return axios.get(`/analytics/requests`, { params });
};

type QueryFnType = typeof getReport;

type UseGetReport = {
  pageIds: string[];
  date: Date;
  config?: QueryConfig<QueryFnType>;
};

export const useGetReport = ({ config = {}, pageIds, date }: UseGetReport) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['analytics-requests', pageIds, date],
    queryFn: () => getReport({ pageIds: pageIds, date: formatDateForServer(date) }),
    cacheTime: 0,
  });
};
